import OrderService from "@/services/orders-service";
export default {
  async setOrders({ commit }, { orderSortType, orderFilter }) {
    const data = await OrderService.getOrders(orderSortType, orderFilter);
    commit("SET_ORDERS", data);
    return data;
  },
};
